import React from 'react'
import "./GraphOne.css"
import { Chart } from "react-google-charts";

export const data = [
    ["Element", "Density", { role: "style" },],
    ["Week 1", 12, "#FEC601"], // RGB value
    ["Week 2", 28, "#FEC601"], // English color name
    ["Week 3", 6, "#FEC601"],
    ["Week 4", 17, "#FEC601"], // CSS-style declaration
    ["Week 4", 23, "#FEC601"],
    
  ];
  export const options = {
    legend: "none",
    chartArea: { left: 40, top: 10, right: 0, bottom: 30 },
    backgroundColor: '#F8FBFF',
  };


const GraphOne = () => {
    
    return (
        <div className='card_graph'>
            <h1 className='part_1'>Total Incidents Recorded</h1>
            <div class="btn-group">
                <button>Days</button>
                <button style={{background: "#004F95", color: "white"}}>Week</button>
                <button>Month</button>
                <button>Custom</button>
            </div>
            <div class="btn-group_1">
                <button style={{background: "#004F95", color: "white"}}>Recorded</button>
                <button onClick={alert}>Cleared</button>
            </div>
            <div className='axis'><span style={{color: "#004F95", fontWeight: "700", fontFamily: "Poppins"}}>X-Axis</span> : Weeks</div>
            <div className='axisy'><span style={{color: "#004F95", fontWeight: "700", fontFamily: "Poppins"}}>Y-Axis</span> : Weeks</div>
            <div className='row'>
                <div className='col-4'>
                    <Chart className='charting' chartType="ColumnChart" data={data} options={options} />
                </div>
            </div>
        </div>
    )
}

export default GraphOne
